import { YoutubeVideoProps } from '../../../types/props'

const YoutubeVideos = ({ src }: YoutubeVideoProps) => {
  return <iframe src={src} width='350' height='200' allowFullScreen />
}

export default YoutubeVideos
